module.exports = __webpack_public_path__ + "img/sudbury_b4.629799ee.jpg";